/* eslint-disable */
import React, { useState } from "react";
import { Form, Button, Input, message } from "antd";
import "./style.css";
import {
  login
} from './../../helper/api_v1/flight_search'
import cookies from 'js-cookie'
import moment from 'moment'
import { useEffect } from "react";



export default function Login(props) {

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    loginHandle(true);
  }, [])


  const loginHandle = async (isChecking = false) => {

    let pin = cookies.get("pin")
    
    if (typeof (pin) !== "undefined") {
      let updocated = atob(pin)

      let diff = moment(moment().diff(moment(updocated))).format("mm:ss")

      diff = diff.split(":")[0]
      diff = Number(diff)

      if (diff < 58) {
        // console.log("l")
        props.login({ loginTrue: true })
      } else {
        // console.log("h")
        cookies.remove("pin")
        window.location.href = "/"
      }

    } else {

      // NOTE Checking Login token isChecking = true or isChecking = false
      if (!isChecking) {
        
        const up = {
          username: username,
          password: password
        }
        
        message.loading("Please Wait...", 0)
        let get = await login(up)

        if (get.status) {
          
          cookies.remove("pin")
          message.destroy()
          message.destroy()
          let time = moment().format()
          cookies.set("pin", btoa(String(time)));
          message.warn("Session Will Expire After 1 hour")
          props.login({ loginTrue: true })
        
        } else {
        
          cookies.remove("pin")
          message.destroy()
          message.warn("username or password not correct")
        
        }
        // -----------
      }
    }
  }


  return (
    <div className="Login" style={{ marginTop: 100 }}>
      <Form layout="vertical">
        <Form.Item label="Username">
          <Input
            autoFocus
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Item>
        <Form.Item label="Password">
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Item>
        <Button
          type="primary"
          style={{ background: "#2db7f5" }}
          block
          size="large"
          onClick={() => {
            loginHandle()
          }}
        >
          Login
        </Button>
      </Form>
    </div>
  );
}